<script lang="ts" setup>
import { LoaderOverlay } from '@shared/ui/loaders'

defineOptions({
  name: 'SkeletonFilesSection',
})

</script>

<template>
  <div class="files skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="./SkeletonFilesSection.scss" />
